<template>

	<footer class="footer-header">

		<div class="footer-grid">

			<div class="footer-section">

				<h3 class="footer-title">Projects</h3>

				<nav class="footer-nav" aria-label="Projects">

					<a
						v-for="item in projectItems"
						:key="item.name"
						:href="item.href"
						class="footer-link"
					>
						<Icon :icon="item.icon"></Icon>
						{{ item.name }}
					</a>

				</nav>

			</div>

			<div class="footer-section">

				<h3 class="footer-title">Links</h3>

				<nav class="footer-nav" aria-label="Links">

					<a
						v-for="item in generalItems"
						:key="item.name"
						:href="item.href"
						class="footer-link"
						:target="item.href.startsWith('http') ? '_blank' : null"
						:rel="item.href.startsWith('http') ? 'noopener noreferrer' : null"
					>
						<Icon :icon="item.icon"></Icon>
						{{ item.name }}
					</a>

				</nav>

			</div>

		</div>

	</footer>

</template>

<script lang="ts">
import { defineComponent } from "vue";
import Icon from "./Icon/Icon.vue";

export default defineComponent({
	name: "Footer",

	components: {
		Icon
	},

	setup() {

		const projectItems = [
			{
				name: "Microsoft Flight Simulator 2024",
				href: "/msfs",
				icon: "msfs",
			},
			{
				name: "Arma 4",
				href: "/arma4",
				icon: "arma4",
			},
			{
				name: "DayZ",
				href: "/dayz",
				icon: "dayz",
			},
			{
				name: "Gallus Engine",
				href: "/gallusengine",
				icon: "gallusengine",
			},
			{
				name: "Gudenuff Engine",
				href: "/gudenuffengine",
				icon: "gudenuffengine",
			},
			{
				name: "CoopScoop",
				href: "/coopscoop",
				icon: "coopscoop",
			},
			{
				name: "Audio Engine",
				href: "/audioengine",
				icon: "audioengine",
			},
			{
				name: "In Sheep's Clothing",
				href: "/insheepsclothing",
				icon: "insheepsclothing",
			}
		];

		const generalItems = [
			{
				name: "CV",
				href: "/src/CV-Kylian-Dekker.pdf",
				icon: "cv"
			},
			{
				name: "About Me",
				href: "/about",
				icon: "user"
			},
			{
				name: "Mail Me",
				href: "mailto:kyliandekker2000@gmail.com",
				icon: "mail"
			},
			{
				name: "LinkedIn",
				href: "https://www.linkedin.com/in/kyliandekker",
				icon: "linkedin"
			},
			{
				name: "GitHub",
				href: "https://github.com/kyliandekker",
				icon: "github"
			}
		];

		return {
			projectItems,
			generalItems
		};
	}
});
</script>

<style lang="scss" scoped>

@import url("/public/src/css/footer.scss");

</style>